"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUnderlyingImpl = new Set(['multi', 'end']);
exports.additionalFunctions = {
    /** promisified multi execution */
    execMulti: (multi) => new Promise((resolve, reject) => multi.exec((err, data) => err ? reject(err) : resolve(data))),
};
